export function collectionsNamespace(http) {
    return {
        /** List collections → unwraps to `{ collections }`. */
        list(opts) {
            return http.get('/collections', { signal: opts?.signal });
        },
        /** Fetch one collection → unwraps to `{ collection }` (or `data`). */
        get(collectionId, opts) {
            return http.get(`/collections/${collectionId}`, { signal: opts?.signal });
        },
        /**
         * Create a collection in the organization currently in context.
         *
         * The scheme must be one that organization is offered, and the call is
         * refused once its collection quota is used up — both enforced server-side.
         * The search index is chosen for you: the most specific one the
         * organization is entitled to.
         */
        create(body) {
            return http.post('/collections', { body });
        },
    };
}
//# sourceMappingURL=collections.js.map